import React, { FC, Ref, forwardRef } from "react";
import dndCss from "../styles/dnd.module.css";

interface DndDividerProps {
	/** show or hide divider */
	show: boolean;
	/** ref */
	ref: Ref<HTMLDivElement>;
}

export const DndDivider: FC<DndDividerProps> = forwardRef(({ show }, ref: Ref<HTMLDivElement>) => (
	<div
		className={dndCss.dropDivider}
		ref={ref}
		style={{ visibility: show ? "visible" : "hidden" }}
	/>
));
